import { render, staticRenderFns } from "./ReserveOrderList.vue?vue&type=template&id=24bfe1ee&scoped=true&"
import script from "./ReserveOrderList.vue?vue&type=script&lang=js&"
export * from "./ReserveOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ReserveOrderList.vue?vue&type=style&index=0&id=24bfe1ee&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bfe1ee",
  null
  
)

export default component.exports